import React from 'react';
import { connect } from 'react-redux';
import veracodeLogo from '~/images/sca-veracode-logo-white.png';
type SourceClearSpinnerProps = {
  vcPageState: object;
};
const SourceClearSpinner: React.SFC<SourceClearSpinnerProps> = props => {
  const {
    vcPageState: { shouldShowVeracodePage },
  } = props;
  return (
    <div className="text--center col-1-1 bg-color--white zIndex-10--loadingPage">
      <div className="font--h1">
        {!shouldShowVeracodePage ? (
          <i className="sci sci__sourceclear-logo--primary sci--sm" />
        ) : (
          <img src={veracodeLogo} className="vc-spinner" />
        )}
      </div>
      <svg width="40" height="40" viewBox="0 0 40 40" className="mt block--center">
        <polygon points="0 0 0 40 40 40 40 0" className="loading--rectangle" />
      </svg>
    </div>
  );
};
function mapStateToProps(state) {
  return {
    vcPageState: state.vcPageState,
  };
}
export default connect(mapStateToProps)(SourceClearSpinner);
